import { useQuery } from '@tanstack/react-query';

export const DEFAULT_COMPANY_INFO = {
    name: '',
    domain: '',
    description: '',
    hasCompanyEmail: false,
};

async function fetchCompanyInfo(domain: string) {
    if (!process.env.NEXT_PUBLIC_GOOGLE_KNOWLEDGE_GRAPH_API_KEY) {
        throw new Error('Google Knowledge Graph API key is not configured');
    }

    const encodedDomain = encodeURIComponent(domain);
    const url = new URL('https://kgsearch.googleapis.com/v1/entities:search');
    url.searchParams.append('query', encodedDomain);
    url.searchParams.append(
        'key',
        process.env.NEXT_PUBLIC_GOOGLE_KNOWLEDGE_GRAPH_API_KEY
    );
    url.searchParams.append('limit', '1');
    url.searchParams.append('types', 'Organization');

    const response = await fetch(url.toString());
    if (!response.ok) {
        throw new Error('Failed to fetch company info');
    }

    const data = await response.json();
    return {
        name: data.itemListElement[0]?.result?.name ?? domain.split('.')[0],
        domain: domain,
        description:
            data.itemListElement[0]?.result?.detailedDescription?.articleBody,
        hasCompanyEmail: true,
    };
}

export function useCompanyInfo(domain: string | null) {
    return useQuery({
        queryKey: ['company-info', domain],
        queryFn: () =>
            domain ? fetchCompanyInfo(domain) : DEFAULT_COMPANY_INFO,
        enabled: !!process.env.NEXT_PUBLIC_GOOGLE_KNOWLEDGE_GRAPH_API_KEY,
    });
}
